import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {isString} from 'lodash';
import {Modal, Button, Label} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import {validateErrorsRequestDevice} from '../../../utils';
import DeviceRequestForm from './deviceRequestForm';

const {
  fetchRequestId,
  addMessageBoxError,
  addRequestsDevice,
  fetchRequestsDetail,
  clearVehiclesInfoList,
  fetchDesisntallationMotives,
} = Actions;

const requestDevice = {
  'requestId': '',
  'motiveCode': '',
  'agency': '',
  'requestType': '',
  'chassis': '',
  'katashiki': '',
  'clientName': '',
  'clientId': '',
  'phone': '',
  'sellerName': '',
  'observations': '',
};

const ModalDeviceRequest = ({dealerId, action, requestType, requestId, dealer}) => {
  const {dealerInfo} = useSelector((state) => state.dealer);
  const {newRequestId, requestDetail, vehicleInfoList} = useSelector(
    (state) => state.requestsDevice
  );
  const [isOpen, setIsOpen] = useState(false);
  const [newRequestDevice, setNewRequestDevice] = useState({...requestDevice});
  const dispatch = useDispatch();

  useEffect(() => {
    if (action === 'create' && newRequestId !== newRequestDevice.requestId) {
      setNewRequestDevice({...newRequestDevice, 'requestId': newRequestId});
    }
    if (action === 'see' && requestDetail.requestId !== newRequestDevice.requestId) {
      setNewRequestDevice({...requestDetail});
    }
  }, [newRequestId, requestDetail]);

  const handleOpenModal = () => {
    setIsOpen(true);
    dispatch(fetchDesisntallationMotives());

    if (action === 'see') {
      dispatch(fetchRequestsDetail(requestType, dealer, requestId));
    }
  };

  const handleCloseModal = () => {
    setIsOpen(false);
    dispatch(clearVehiclesInfoList());
    setNewRequestDevice(requestDevice);
  };

  const handleSaveDeviceRequest = () => {
    const {error, message} = validateErrorsRequestDevice(newRequestDevice);
    if (error) {
      dispatch(addMessageBoxError(message));
      return;
    }
    dispatch(addRequestsDevice({...newRequestDevice, 'dealer': dealerId}));
    handleCloseModal();
  };

  const handleChange = (e, {name, value}) => {
    const finalValue = isString(value) ? value.toUpperCase() : value;
    if (name === 'requestType') {
      dispatch(fetchRequestId(value));
    } else if (name === 'chassis') {
      const vehicle = vehicleInfoList.find((vehicle) => vehicle.chassis === finalValue);
      setNewRequestDevice({...newRequestDevice, ...vehicle});
      return;
    }
    setNewRequestDevice({...newRequestDevice, [name]: finalValue});
  };

  return (
    <Modal
      className="request-device-modal"
      size="large"
      open={isOpen}
      onClose={handleCloseModal}
      closeIcon
      trigger={
        action === 'create' ? (
          <Button primary onClick={handleOpenModal}>
            Agregar
          </Button>
        ) : (
          <span className="link" onClick={handleOpenModal}>
            <i className="material-icons">visibility</i>
          </span>
        )
      }
    >
      <Modal.Header>
        {action === 'create' ?
          `Nueva Solicitud de ${dealerInfo.name}` :
          `Solicitud de ${dealerInfo.name}`
        }
        {newRequestDevice.requestId && (
          <Label className="total" color="blue">
            No Solicitud
            <Label.Detail>{newRequestDevice.requestId}</Label.Detail>
          </Label>
        )}
      </Modal.Header>
      <Modal.Content>
        <DeviceRequestForm
          action={action}
          newRequestDevice={newRequestDevice}
          handleChange={handleChange}
          dispatch={dispatch}
        />
      </Modal.Content>
      <Modal.Actions>
        {action === 'create' && (
          <Button color="green" onClick={handleSaveDeviceRequest}>
            Crear solicitud
          </Button>
        )}
      </Modal.Actions>
    </Modal>
  );
};

export default ModalDeviceRequest;
